import { render, staticRenderFns } from "./ValueWidget.vue?vue&type=template&id=11c15b0a&scoped=true"
import script from "./ValueWidget.vue?vue&type=script&lang=js"
export * from "./ValueWidget.vue?vue&type=script&lang=js"
import style0 from "./ValueWidget.vue?vue&type=style&index=0&id=11c15b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c15b0a",
  null
  
)

export default component.exports